import React, { Component } from 'react';
import axios from 'axios';
import { Box, Card, CardContent, Grid, TextField, Typography, Link } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Seo from '../Seo/Seo';

const styles = theme => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'radial-gradient(circle at top, #1c2c2f 0%, #0f1116 45%, #0a0c10 100%)',
    padding: theme.spacing(4),
  },
  card: {
    textAlign: 'left',
    background: 'rgba(20, 24, 28, 0.86)',
    color: '#f5f7fa',
    borderRadius: 24,
    border: '1px solid rgba(255,255,255,0.08)',
    boxShadow: '0 24px 70px rgba(0,0,0,0.45)',
    backdropFilter: 'blur(16px)',
  },
  cardContent: {
    padding: theme.spacing(4),
  },
  heading: {
    color: '#72f7c4',
    fontWeight: 700,
  },
  subheader: {
    color: 'rgba(245, 247, 250, 0.7)',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  form: {
    display: 'grid',
    gap: theme.spacing(2),
  },
  field: {
    width: '100%',
  },
  input: {
    color: '#f5f7fa',
  },
  cssLabel: {
    color: 'rgba(245, 247, 250, 0.7)',
    '&$cssFocused': {
      color: '#72f7c4',
    },
  },
  cssOutlinedInput: {
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    borderRadius: 14,
    '&$cssFocused $notchedOutline': {
      borderColor: '#72f7c4',
      borderWidth: 2,
    },
  },
  cssFocused: {},
  notchedOutline: { borderColor: 'rgba(255,255,255,0.16)' },
  button: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.4, 0),
    fontWeight: 600,
    borderRadius: 14,
    background: 'linear-gradient(135deg, #72f7c4 0%, #4ad6ff 100%)',
    color: '#0a0c10',
    textTransform: 'none',
  },
  link: {
    color: '#9cefd2',
    marginTop: theme.spacing(2),
    display: 'inline-block',
  },
  successMessage: {
    marginTop: theme.spacing(1),
    color: '#ccffef',
    background: 'rgba(114, 247, 196, 0.12)',
    border: '1px solid rgba(114, 247, 196, 0.35)',
    borderRadius: 10,
    padding: theme.spacing(1.5),
  }
});

class ForgotPasswordPage extends Component {
  state = {
    email: '',
    isSubmitting: false,
    submitted: false,
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    if (!this.state.email || this.state.isSubmitting) {
      return;
    }

    this.setState({ isSubmitting: true });

    try {
      await axios.post('/api/auth/forgot-password', { email: this.state.email.trim() });
    } catch (error) {
      console.error('[forgot-password] Request failed.');
    } finally {
      this.setState({ isSubmitting: false, submitted: true });
    }
  }

  render() {
    const { classes, history } = this.props;

    return (
      <Box className={classes.root}>
        <Seo
          title="Forgot Password | Trivia Weekend"
          description="Request a secure password reset link for your Trivia Weekend account."
          canonicalPath="/#/forgot-password"
          ogType="website"
        />
        <Grid container justify="center">
          <Grid item xs={12} sm={10} md={7} lg={5}>
            <Card className={classes.card}>
              <CardContent className={classes.cardContent}>
                <Typography variant="h4" component="h1" className={classes.heading}>
                  Forgot your password?
                </Typography>
                <Typography variant="subtitle1" className={classes.subheader}>
                  Enter your email and we will send a password reset link if an account exists.
                </Typography>

                <form onSubmit={this.handleSubmit} className={classes.form}>
                  <TextField
                    label="Email Address"
                    className={classes.field}
                    value={this.state.email}
                    onChange={(event) => this.setState({ email: event.target.value })}
                    margin="normal"
                    variant="outlined"
                    InputProps={{
                      className: classes.input,
                      classes: {
                        root: classes.cssOutlinedInput,
                        focused: classes.cssFocused,
                        notchedOutline: classes.notchedOutline,
                      }
                    }}
                    InputLabelProps={{
                      className: classes.cssLabel,
                      shrink: true
                    }}
                  />
                  <Button className={classes.button} type="submit" disabled={this.state.isSubmitting}>
                    {this.state.isSubmitting ? 'Sending…' : 'Send reset link'}
                  </Button>
                </form>

                {this.state.submitted && (
                  <Typography className={classes.successMessage}>
                    If an account exists, we emailed a link to reset your password.
                  </Typography>
                )}

                <Link component="button" onClick={() => history.push('/login')} className={classes.link}>
                  Back to login
                </Link>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default withRouter(withStyles(styles)(ForgotPasswordPage));
